import {
  CreateExchangeRateCommand,
  CryptoCurrencyEnum,
  ExchangeRateHistroryResponse,
  ExchangeRateRangeListResponse,
  ExchangeRateStatusEnum,
  ExchangeRateTypeEnum,
  GetExchangeRateRangeListQueryOrganizationFilterEnum,
  PagedResponse_ExchangeRateRangeListResponse,
  PagedResponse_RecommendedRateResponse,
} from '@acme/api';

export type PagedClientExchangeRateResponse =
  PagedResponse_ExchangeRateRangeListResponse;
export type ClientExchangeRateResponse = ExchangeRateRangeListResponse;
export type PagedClientRecommendedRateResponse =
  PagedResponse_RecommendedRateResponse;
export type ExchangeRateHistoryListResponse = ExchangeRateHistroryResponse;
export type AddExchangeRateRequest = CreateExchangeRateCommand;
export type ExchangeRateFilter = {
  search?: string;
  type?: ExchangeRateTypeEnum;
  cryptoCurrencies?: Array<CryptoCurrencyEnum>;
  currencies?: Array<number>;
  amountMin?: number;
  amountMax?: number;
  organziationFilter?: GetExchangeRateRangeListQueryOrganizationFilterEnum;
  pageNumber?: number;
  pageSize?: number;
};

export const EExchangeRateStatusEnum = { ...ExchangeRateStatusEnum } as const;
export type RecommendedRateFilter = Pick<
  ExchangeRateFilter,
  'cryptoCurrencies' | 'currencies' | 'pageNumber' | 'pageSize'
>;
